import React, { useRef } from "react"
import {
  Flex, FormLabel, Select, Stack,
} from "@chakra-ui/react"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import EditorSection from "components/Builder/components/EditorSection"
import { MERGE_TAGS } from "utilities/enums"
import HTMLEditor from "components/ReactHookForm/HTMLEditor"
import { Control } from "react-hook-form"
import withMergeTags from "../withMergeTags"

type Props = {
  name: string
  control: Control
  insertTag: (id: string) => void
  handleSelectionChange: () => void
  showMergeTags?: boolean
}
const HtmlFields = withMergeTags(({
  name, control, insertTag, handleSelectionChange, showMergeTags = true,
}: Props) => {
  const selectRef = useRef<HTMLSelectElement>(null)

  const handleSelectMergeField = (event) => {
    const selectedMergeTagId = MERGE_TAGS.find(({ id }) => id === event.target.value)?.id

    if (!selectedMergeTagId) {
      return
    }

    insertTag(selectedMergeTagId)

    if (selectRef.current) {
      selectRef.current.value = ""
    }
  }

  return (
    <Stack height="full">
      <SidePanelHeader>HTML Block</SidePanelHeader>
      <EditorSection grow>
        <Stack gap={5}>
          {showMergeTags && (
            <Flex>
              <FormLabel w="30%" mt={2} fontWeight="semibold">Merge Fields</FormLabel>
              <Select bg="white" placeholder="Select field to insert..." onChange={handleSelectMergeField} ref={selectRef}>
                {MERGE_TAGS.map(({ id, label }) => <option key={id} value={id}>{label}</option>)}
              </Select>
            </Flex>
          )}
          <HTMLEditor name={name} control={control} fullHeight onBlur={handleSelectionChange} />
        </Stack>
      </EditorSection>
    </Stack>
  )
},

"html")

export default HtmlFields
